module.exports = __webpack_public_path__ + "img/wallstreet-logo.54ac8e27.svg";